const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      authorization: token,
    },
  };
};

export default getAuthHeader;
